export default "__VITE_ASSET__EDBu$oCy__"